// extracted by css-extract-rspack-plugin
export default {"root":"K4dr_","item":"ce8Ua","control":"mXT53","label":"a498B","chevron":"MqME4","icon":"QWmN_","content":"DxC05","panel":"Yn6q9"};